module.exports = __webpack_public_path__ + "img/1-1.462446d5.png";